import React from 'react';

const Pago = () => {
  return <div className="text-center mt-10 text-xl">Página de Pago</div>;
};

export default Pago;